export const DEFAULT_STRING_JOIN = ', '
